export const SRCSET_SIZES = [
    200, // portrait mobile 1x
    320, // landscape mobile 1x
    400, // portrait mobile 2x
    640, // landscape mobile 2x
    800, // portrait mobile 3x
    960, // landscape mobile 3x
];

/**
 * Returns a single url with passed fastly options as query params.
 *
 * @export
 * @param {string} url - url of the image
 * @param {number} width - desired image width
 * @param {number} [quality=60] - image quality
 * @returns {string}
 */
export function getSrcsetUrl(url, width, quality = 60) {
    return `${url}?disable=upscale&quality=${quality}&width=${width}`;
}

/**
 * Builds a src set string to be used accross this app.
 *
 * @export
 * @param {string} url - url of the image
 * @returns {string}
 */
export function getSrcsetString(url) {
    return SRCSET_SIZES.map(width => `${getSrcsetUrl(url, width)} ${width}w`).join(', ');
}

// TODO: Get srcSetString from shared place i.e. dibs-components
export const getThumbsSrcSetString = ({ url, quality = 60 }) => {
    if (!url) {
        return url;
    }
    return [60, 120]
        .map(
            (width, index) =>
                `${url}?disable=upscale&auto=webp&srcset=disallow&quality=${quality}&width=${width} ${index +
                    1}x`
        )
        .join(', ');
};
